import React from 'react'
import { Col, Row } from 'antd'
import { ContentInputField } from '../../../../../components/atoms/formFields/inputField/contentInputField'
import TinyEditor from '../../../../../components/atoms/formFields/tinyEditor'

const AboutDetail = ({ lang, langKey, productbase, detail }) => {
    return (
        <div>
            {productbase !== "SEEDS" &&
                (productbase !== "FEED_SUPPLEMENT" &&
                    productbase !== "MACHINERY" ? (
                    <Row className="mb-5" gutter={[10, 10]}>
                        <Col className="gutter-row" xs={24} lg={6}>
                            <ContentInputField
                                name={`Technical Name ${lang}`}
                                disabled={true}
                                value={
                                    detail?.productDetails?.composition
                                        ?.technicalName?.[langKey]
                                }
                            />
                        </Col>
                    </Row>
                ) : (
                    <Row className="mb-5" gutter={[10, 10]}>
                        <Col className="gutter-row" xs={24} lg={6}>
                            <ContentInputField
                                name={`Manufacturing Date ${lang}`}
                                disabled={true}
                                value={
                                    detail?.productDetails
                                        ?.dateOfManufacturing?.[langKey]
                                }
                            />
                        </Col>
                        {productbase !== "MACHINERY" && (
                            <Col className="gutter-row" xs={24} lg={6}>
                                <ContentInputField
                                    name={`Expiry Date ${lang}`}
                                    className="h-40px rounded text-dark m-0"
                                    disabled={true}
                                    value={
                                        detail?.productDetails?.expiryDate?.[langKey]
                                    }
                                />
                            </Col>
                        )}
                    </Row>
                ))}

            <div className="card-body p-0">
                <label className="font-weight-bolder font-size-md">
                    About Item
                </label>
                <TinyEditor
                    disabled={true}
                    value={detail?.about?.aboutItem?.[langKey]}
                />{" "}
            </div>

            <div className="separator separator-solid my-5"></div>

            <div className="card-body p-0">
                <label className="font-weight-bolder font-size-md">
                    Product Review
                </label>
                <TinyEditor
                    disabled={true}
                    value={
                        detail?.about?.apniKhetiProductReview?.text
                            ?.[langKey]
                    }
                />
            </div>

            <div className="separator separator-solid my-5"></div>

            <div className="card-body p-0">
                <label className="font-weight-bolder font-size-md">
                    How to Use
                </label>
                <TinyEditor
                    disabled={true}
                    value={detail?.about?.howToUse?.text?.[langKey]}
                />
            </div>

            <div className="separator separator-solid my-5"></div>

            {productbase !== "MACHINERY" && (
                <div className="card-body p-0">
                    <label className="font-weight-bolder font-size-md">
                        Storage Info
                    </label>
                    <TinyEditor
                        disabled={true}
                        value={detail?.productDetails?.storage?.[langKey]}
                    />
                </div>
            )}

            <div className="separator separator-solid my-5"></div>

            <div className="card-body p-0">
                <label className="font-weight-bolder font-size-md">
                    Special Instructions (if any)
                </label>
                <TinyEditor
                    disabled={true}
                    value={detail?.productDetails?.instructions?.[langKey]}
                />
            </div>

            <div className="separator separator-solid my-5"></div>

            <div className="card-body p-0">
                <label className="font-weight-bolder font-size-md">
                    Precaution (if any)
                </label>
                <TinyEditor
                    disabled={true}
                    value={detail?.productDetails?.precautions?.[langKey]}
                />
            </div>

            <div className="separator separator-solid my-5"></div>

            {productbase === "SEEDS" && (
                <div className="card-body p-0">
                    <label className="font-weight-bolder font-size-md">
                        Specialty
                    </label>
                    <TinyEditor
                        disabled={true}
                        value={detail?.productDetails?.speciality?.[langKey]}
                    />
                </div>
            )}
        </div>
    )
}

export default AboutDetail